import { render, staticRenderFns } from "./lrBMapPanel.vue?vue&type=template&id=2271fb62&"
import script from "./lrBMapPanel.vue?vue&type=script&lang=js&"
export * from "./lrBMapPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports